import getSelectedElementsByTag from './get-selected-elements-by-tag';
import getElementAttributes from './get-element-attributes';
import wrappersTypes from '../../text-formatting/constants/wrappers-types';
import textFormatting from '../../text-formatting';

const cleanFormatting = () =>
  [wrappersTypes.decoration, wrappersTypes.customColor].forEach(({ tagName, className, id }) => {
    const tags = getSelectedElementsByTag(tagName);

    tags.forEach((tag) => {
      tag.removeAttribute('class');
      tag.classList.add(className);

      const attributes = getElementAttributes(tag);
      textFormatting.helpers.wrapperMap.registerWrapper(id, className, tagName, attributes);
      textFormatting.operations.undoWrapper(id);
      textFormatting.helpers.wrapperMap.removeWrapper(id);
    });
  });

export default cleanFormatting;
